import { render } from "./PublicHeader.vue?vue&type=template&id=0682ce19&scoped=true"
const script = {}

import "./PublicHeader.vue?vue&type=style&index=0&id=0682ce19&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0682ce19"

export default script